import { type BaseSelectProps, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { BrandKitImageType } from "../brand-kit/server/brand-kit-service";

interface ImageShapeSelectProps extends Omit<BaseSelectProps, "onChange"> {
  onChange: (style: BrandKitImageType) => void;
  imageType: BrandKitImageType;
}

export const ImageShapeSelect: FC<ImageShapeSelectProps> = ({ onChange, imageType, ...props }) => {
  const { t } = useTranslation();
  const label = t("Image shape");

  return (
    <FormControl>
      <InputLabel htmlFor="image-shape-select">{label}</InputLabel>
      <Select
        id="image-shape-select"
        value={imageType ?? "square"}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val as BrandKitImageType);
        }}
        sx={{ width: "7em" }}
        label={label}
        inputProps={{
          "aria-label": label,
        }}
        {...props}
      >
        <MenuItem value="square">{t("Square")}</MenuItem>
        <MenuItem value="banner">{t("Banner")}</MenuItem>
      </Select>
    </FormControl>
  );
};
